/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useImmer } from "use-immer";
import { usePermission } from "../../../shared";
import { AppContext } from "../../../store/AppScopeProvider";
import { errorMessage, successMessage, } from "../../../utils";
import {
  changeClientAccountsAddressDefaultApi,
  createClientAccountsAddressApi,
  deleteClientAccountsAddressApi,
  getClientAccountsAddressApi,
  updateClientAccountsAddressApi,
} from "../api";

export const useClientAccountAddress = ({ id }) => {
  const { appState } = useContext(AppContext);
  const {
    currentTabs: { clientAccV2List: currentTab },
    globalData,
  } = appState;

  const isEditable = usePermission("client-account-address-modify");
  const isDeletable = usePermission("client-account-address-delete");
  const isCreateble = usePermission("client-account-address-create");

  const { pathname } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");

  const [state, setState] = useImmer({
    isLoading: true,
    dataList: [],
    updateData: {
      name: "",
      address: "",
      email: "",
      phone: "",
      country_code: 61,
    },
    isSaveButton: false,
    isOpenModal: false,
    isModalType: 'add',
    isOpenDelete: false,
    selectedID: null,
  })

  const handleClientAccountAddressList = async (
  ) => {
    try {
      setState((draft) => {
        draft.isLoading = true;
      });
      const res = await getClientAccountsAddressApi(id);
      if (res.success) {
        setState((draft) => {
          draft.dataList = res.data;
          draft.isLoading = false;
        });
      }
    } catch (err) {
      errorMessage(err.response.data.message);
      setState((draft) => {
        draft.isLoading = false;
      });
    }
  };

  useEffect(() => {
    handleClientAccountAddressList()
  }, [])


  const handleInputChange = (event) => {
    const { value, name } = event.target

    setState((draft) => {
      draft.updateData = {
        ...draft.updateData,
        [name]: value,
      };
    });
  }

  const onCreateAddress = async () => {
    try {
      setState((draft) => {
        draft.isSaveButton = true;
      });
      let payload = { ...state.updateData, client_account_id: id }
      const res = await createClientAccountsAddressApi(payload);
      if (res.success) {
        successMessage(res.message);
        setState((draft) => {
          draft.isSaveButton = false;
          draft.isOpenModal = false;
        });
        handleClientAccountAddressList()
      } else {
        errorMessage(res.message)
      }
    } catch (err) {
      errorMessage(err.response.data.message);
      setState((draft) => {
        draft.isSaveButton = false;
      });
    }
  };

  const onUpdateAddress = async () => {
    try {
      setState((draft) => {
        draft.isSaveButton = true;
      });

      let { name, address, email, phone, country_code } = state.updateData;
      let payload = { name, address, email, phone, country_code, client_account_id: id };
      const res = await updateClientAccountsAddressApi(payload, state.selectedID);
      if (res.success) {
        successMessage(res.message);
        setState((draft) => {
          draft.isSaveButton = false;
          draft.isOpenModal = false;
          draft.updateData = {
            name: "",
            address: "",
            email: "",
            phone: "",
            country_code: 61,
          }
        });
        handleClientAccountAddressList();
      } else {
        errorMessage(res.message);
      }
    } catch (err) {
      errorMessage(err.response.data.message);
      setState((draft) => {
        draft.isSaveButton = false;
      });
    }
  };


  const onDeleteAddress = async (id) => {
    try {
      const res = await deleteClientAccountsAddressApi(state.selectedID);
      if (res.success) {
        successMessage(res.message);
        setState((draft) => {
          draft.isOpenDelete = false;
        });
        handleClientAccountAddressList()
      } else {
        errorMessage(res.message)
      }
    } catch (err) {
      errorMessage(err.response.data.message);
    }
  };

  const handleModal = (type, state, data) => {
    switch (type) {
      case "add":
        setState((draft) => {
          draft.isOpenModal = state;
          draft.isModalType = type
          draft.updateData = {
            name: "",
            address: "",
            email: "",
            phone: "",
            country_code: 61,
          }
        });
        break;
      case "edit":
        setState((draft) => {
          draft.isOpenModal = state;
          draft.isModalType = type
          draft.updateData = data
          draft.selectedID = data.id
        });
        break;
      case "delete":
        setState((draft) => {
          draft.isOpenDelete = state;
          draft.selectedID = data;
        });
        break;
    }
  };

  const onChangeDefault = async (id) => {
    try {
      const res = await changeClientAccountsAddressDefaultApi(id);
      if (res.success) {
        successMessage(res.message);
        handleClientAccountAddressList()
      } else {
        errorMessage(res.message)
      }
    } catch (err) {
      errorMessage(err.response.data.message);
    }
  };



  return {
    state,
    currentTab,
    isDeletable,
    isCreateble,
    isEditable,
    isStoreAdmin,
    globalData,
    handleInputChange,
    onCreateAddress,
    onUpdateAddress,
    handleModal,
    onDeleteAddress,
    onChangeDefault,
  };
};
